import axios from 'axios'
import config from '../config'

export default {
    request(method, uri, data = null) {
        if (!method) {
            console.error('API function call requires method argument')
            return
        }
        if (!uri) {
            console.error('API function call requires uri argument')
            return
        }
        var url = config.serverURI + uri
        return axios({ method, url, data })
    },
    setdate(fecha) {
        var today = fecha;
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }

        if (mm < 10) {
            mm = "0" + mm;
        }

        today = yyyy + "/" + mm + "/" + dd;
        //today = dd + '-' + mm + '-' + yyyy;
        console.log(today);
        return today;
    }
}
